#storage-protection-exclusions-content {
  width: 100% !important;

  #storage-protection-exclusions-info-text {
    color: var(--body-text-arrows-400);
  }
}
